/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The OffersValidationRequest model module.
 * @module model/OffersValidationRequest
 * @version v1
 */
export class OffersValidationRequest extends Array {
  /**
   * Constructs a new <code>OffersValidationRequest</code>.
   * @alias module:model/OffersValidationRequest
   * @class
   * @extends Array
   */
  constructor() {
    super();
  }

  /**
   * Constructs a <code>OffersValidationRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OffersValidationRequest} obj Optional instance to populate.
   * @return {module:model/OffersValidationRequest} The populated <code>OffersValidationRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OffersValidationRequest();
      ApiClient.constructFromObject(data, obj, 'Array');
    }
    return obj;
  }
}
